export default "__VITE_ASSET__BNxd0q20__"